import './style.scss'
// NoScroll.js
export default {
  name: 'HiddenScrollbars',
  functional: true,
  render(h, context) {
    // Get the first child from the default slot
    const defaultSlot = context.slots().default || []
    const child = defaultSlot[0]
    if (!child) return null

    // Ensure child has a data object
    child.data = child.data || {}

    // Append 'no-scroll' to the child's staticClass
    const staticClass = child.data.staticClass
      ? `${child.data.staticClass} no-scrollbar`
      : 'no-scrollbar'
    child.data.staticClass = staticClass

    // Return the original child (no extra DOM)
    return child
  },
}
